import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getDashboard } from "@/services/dashboard.service";
import { listContracts } from "@/services/contracts.service";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Plus, Send } from "lucide-react";
import KarmaBadge from "@/components/shared/KarmaBadge";
import { CreateInvoiceModal } from "@/components/invoices/CreateInvoiceModal";
import DashboardStats from "@/components/dashboard/DashboardStats";
import RecentContracts from "@/components/dashboard/RecentContracts";
import { usePolling } from "@/lib/usePolling";

const Dashboard = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);
  const [contracts, setContracts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [invoiceOpen, setInvoiceOpen] = useState(false);

  const load = async () => {
    try {
      const [d, c] = await Promise.all([getDashboard(), listContracts()]);
      setStats(d);
      setContracts(c.slice(0, 8));
    } catch {} finally {
      setLoading(false);
    }
  };
  useEffect(() => { load(); }, []);
  usePolling(load);

  const isAdmin = user?.role === "admin";

  return (
    <div className="space-y-6" data-testid="dashboard-page">
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground font-semibold">
            Dashboard
          </div>
          <h1 className="mt-1 text-3xl font-bold tracking-tight sm:text-4xl">
            Welcome, {user?.name?.split(" ")[0]}
          </h1>
          {!isAdmin && user?.user_id && (
            <div className="mt-3">
              <KarmaBadge userId="me" />
            </div>
          )}
        </div>
        {!isAdmin && (
          <div className="flex flex-wrap gap-2">
            <Button
              variant="outline"
              onClick={() => setInvoiceOpen(true)}
              data-testid="dashboard-request-payment-btn"
            >
              <Send className="w-4 h-4 mr-1.5" /> Request payment
            </Button>
            <Link to="/contracts/new">
              <Button data-testid="dashboard-new-contract-btn">
                <Plus className="w-4 h-4 mr-1.5" /> New contract
              </Button>
            </Link>
          </div>
        )}
      </div>

      <CreateInvoiceModal open={invoiceOpen} onClose={() => setInvoiceOpen(false)} onCreated={() => {}} />

      <DashboardStats stats={stats} isAdmin={isAdmin} loading={loading} />

      <RecentContracts contracts={contracts} isAdmin={isAdmin} loading={loading} />
    </div>
  );
};

export default Dashboard;
